import {
  Alarm,
  Archive,
  ArrowCircleDown,
  ArrowClockwise,
  ArrowLeft,
  Bell,
  Buildings,
  Cake,
  CalendarBlank,
  CalendarCheck,
  CalendarDots,
  Camera,
  CameraPlus,
  CaretLeft,
  Chat,
  ChatCircle,
  Chats,
  ChatsCircle,
  Check,
  CheckCircle,
  Clock,
  ClockCounterClockwise,
  CloudSlash,
  Coffee,
  Compass,
  DiceFive,
  DownloadSimple,
  Envelope,
  EnvelopeOpen,
  Eye,
  EyeSlash,
  FileText,
  Fingerprint,
  Flag,
  Funnel,
  GoogleLogo,
  Heart,
  Hourglass,
  House,
  Image,
  ImageSquare,
  Images,
  Link,
  Lock,
  MagnifyingGlass,
  MapPin,
  MinusCircle,
  Money,
  NavigationArrow,
  NotePencil,
  PaperPlaneTilt,
  PencilSimple,
  PersonSimpleHike,
  PlusCircle,
  PlusSquare,
  PushPin,
  ShareNetwork,
  ShieldCheck,
  SignOut,
  SlidersHorizontal,
  SoccerBall,
  Sparkle,
  Star,
  Ticket,
  Tree,
  User,
  UserCircle,
  UserMinus,
  UserPlus,
  Users,
  UsersThree,
  X,
  XCircle,
} from '@phosphor-icons/react'
import type { Icon } from '@phosphor-icons/react'

/**
 * Canonical mapping from the Flutter `KuniriIcons` names to Phosphor Bold React
 * components. Feature code imports `KuniriIcons.<name>` and sets
 * `weight={kuniriIconWeight}` (or uses `<KuniriIcon name=... />`).
 *
 * Do not replace these with a different icon family or emoji: the app uses
 * Phosphor Bold, matching the frozen Flutter icon set.
 */
export const kuniriIconWeight = 'bold' as const

export const KuniriIcons = {
  alarm: Alarm,
  archive: Archive,
  arrowCircleDown: ArrowCircleDown,
  arrowClockwise: ArrowClockwise,
  arrowLeft: ArrowLeft,
  bell: Bell,
  buildings: Buildings,
  cake: Cake,
  calendarBlank: CalendarBlank,
  calendarCheck: CalendarCheck,
  calendarDots: CalendarDots,
  camera: Camera,
  cameraPlus: CameraPlus,
  caretLeft: CaretLeft,
  chat: Chat,
  chatCircle: ChatCircle,
  chats: Chats,
  chatsCircle: ChatsCircle,
  check: Check,
  checkCircle: CheckCircle,
  clock: Clock,
  clockCounterClockwise: ClockCounterClockwise,
  cloudSlash: CloudSlash,
  coffee: Coffee,
  compass: Compass,
  diceFive: DiceFive,
  downloadSimple: DownloadSimple,
  envelope: Envelope,
  envelopeOpen: EnvelopeOpen,
  eye: Eye,
  eyeSlash: EyeSlash,
  fileText: FileText,
  fingerprint: Fingerprint,
  flag: Flag,
  funnel: Funnel,
  googleLogo: GoogleLogo,
  heart: Heart,
  hourglass: Hourglass,
  house: House,
  image: Image,
  imageSquare: ImageSquare,
  images: Images,
  link: Link,
  lock: Lock,
  magnifyingGlass: MagnifyingGlass,
  mapPin: MapPin,
  minusCircle: MinusCircle,
  money: Money,
  navigationArrow: NavigationArrow,
  notePencil: NotePencil,
  paperPlaneTilt: PaperPlaneTilt,
  pencilSimple: PencilSimple,
  personSimpleHike: PersonSimpleHike,
  plusCircle: PlusCircle,
  plusSquare: PlusSquare,
  pushPin: PushPin,
  shareNetwork: ShareNetwork,
  shieldCheck: ShieldCheck,
  signOut: SignOut,
  slidersHorizontal: SlidersHorizontal,
  soccerBall: SoccerBall,
  sparkle: Sparkle,
  star: Star,
  ticket: Ticket,
  tree: Tree,
  user: User,
  userCircle: UserCircle,
  userMinus: UserMinus,
  userPlus: UserPlus,
  users: Users,
  usersThree: UsersThree,
  x: X,
  xCircle: XCircle,
} satisfies Record<string, Icon>

export type KuniriIconName = keyof typeof KuniriIcons
